// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-select/src/scss/vue-select.scss
// module id = 4K1A
// module chunks = 1